import { Text, View } from "react-native";
import { MoonDivider } from "./MoonDivider";
import { semanticColors } from "../theme/tokens";

export type AuthDividerProps = {
  label: string;
};

/**
 * The shared separator between phone authentication and alternate methods.
 * The label is supplied by the caller so the primitive stays locale-agnostic.
 */
export function AuthDivider({ label }: AuthDividerProps) {
  return (
    <View
      style={{
        flexDirection: "row",
        alignItems: "center",
        marginVertical: 20,
      }}
    >
      <MoonDivider
        color={semanticColors.onDark.fill.strong}
        style={{ flex: 1 }}
      />
      <Text
        style={{
          fontSize: 11,
          fontWeight: "500",
          letterSpacing: 1.2,
          color: semanticColors.onDark.text.tertiary,
          textTransform: "uppercase",
          marginHorizontal: 14,
        }}
      >
        {label}
      </Text>
      <MoonDivider
        color={semanticColors.onDark.fill.strong}
        style={{ flex: 1 }}
      />
    </View>
  );
}
